import AddIcon from "@mui/icons-material/Add";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useRef } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { selectFiles, selectFormData } from '../../../Store/userSlice';
import DirectorDocumentSet from "../../common/DirectorDocuments/DirectorDocumentSet";
import { createKYCValidationRules } from "../../common/ValidationRules/validationRules";
import "./BlurredDoc.css";
const PromoterKYCDocUploadForm = React.forwardRef((props, ref) => {
  const files = useSelector(selectFiles);
  const appendedRef = useRef(false);
  const formData = useSelector(selectFormData)
  const kycName = formData?.entityType === "partnership_firm" ? "Partner" : formData?.entityType === "propreitorship_firm"?"Proprietor":"Promoter"
  const {
    control,
    register,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      directors: [{ pan: null, aadhar: null }],
    },
  });

  React.useImperativeHandle(ref, () => ({
    validateForm: async () => {
      return true;
    },
  }));

  const { fields, append, remove } = useFieldArray({
    control,
    name: "directors",
    rules: {
      validate: {
        atLeastOne: (value) =>
          value.length > 0 || "At least one director is required",
      },
    },
  });

  useEffect(() => {
    const panLength = files?.panCard?.length || 0;
    const aadharLength = files?.AadharCard?.length || 0;
    const maxLength = Math.max(panLength, aadharLength);
    if (!appendedRef.current && maxLength > 1) {
      for (let i = 1; i < maxLength; i++) {
        append({ pan: null, aadhar: null });
      }
      appendedRef.current = true;
    }
  }, [files, append]);

  const handleAddDirector = () => {
    append({ pan: null, aadhar: null });
  };

  return (
    <Box>
      <Typography variant="body2" sx={{ color: "#666", mb: 3 }}>
        Step 3/5
      </Typography>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 3,
          justifyContent: "flex-end",
        }}
      >
        <Typography sx={{ color: "#666" }}>
          Upload files in JPEG, PNG, or PDF format, up to 5 MB in size.
        </Typography>
        <InfoOutlinedIcon sx={{ ml: 1, color: "#666", fontSize: 20 }} />
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        {fields.map((field, index) => (
          <DirectorDocumentSet
            control={control}
            key={field.id}
            index={index}
            register={register}
            errors={errors}
            setValue={setValue}
            onRemove={remove}
            defaultExpanded={index === 0}
            validationRules={createKYCValidationRules()}
            kycName={kycName}
          />
        ))}
        {errors?.directors && (
          <Typography
            variant="caption"
            color="error"
            sx={{ display: "block", mt: 1 }}
          >
            {errors?.directors?.message}
          </Typography>
        )}

        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <Button
            startIcon={<AddIcon />}
            onClick={handleAddDirector}
            sx={{
              color: "#0066CC",
              textTransform: "none",
              border: "1px solid #0066CC",
              "&:hover": {
                backgroundColor: "rgba(0, 102, 204, 0.04)",
              },
            }}
          >
            Add more {kycName}
          </Button>
        </Box>
      </Box>
    </Box>
  );
});

export default PromoterKYCDocUploadForm;
